import React from "react";
import Slider from "react-slick";
import VendorCard from "./VendorCard";


const VendorCarousel = ({ vendors = [] }) => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: "cubic-bezier(0.87, 0, 0.13, 1)",
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
    appendDots: dots => (
      <div style={{ bottom: "-40px" }}>
        <ul className="m-0 p-0 flex justify-center items-center gap-2"> {dots} </ul>
      </div>
    ),
    customPaging: i => (
      <div className="dot-custom transition-all duration-300 rounded-full bg-gray-300"></div>
    )
  };

  return (
    <div className="w-full py-4 relative">
      <Slider {...settings} >
        {vendors.map((vendor) => (
          <div key={vendor.id} className="px-3">
            <VendorCard vendor={vendor} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default VendorCarousel;
